import React from 'react'

import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CheckCircle from 'mdi-material-ui/CheckCircle'
import {useTranslation} from "next-i18next"
import Grid from '@mui/material/Grid'
import {useSelector} from "../../store";
import {Box, Button} from "@mui/material";
import NextLink from "next-translate-routes/link";
import Card from "@mui/material/Card";

export const HasAcceptanceCard = () => {
    const {t, i18n} = useTranslation()


    const {firstName, username} = useSelector((state) => state.userSession.currentProfile);

    //const port = (window.location.port443 || window.location.port === 443 || window.location.port === 80)? '' : ':' + window.location.port

    return <Card square sx={{border: '1px solid #00c162'}} elevation={8}>
        <CardContent>
            <Typography gutterBottom variant="subtitle1">
                <CheckCircle htmlColor={'#11873b'}
                             style={{
                                 marginBottom: 4,
                                 marginRight: 4,
                                 verticalAlign: "middle"
                             }}/>{t('profile-accepted-title')}</Typography>

            <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-evenly'} spacing={3}>
                <Grid item xs={12} sm={4} style={{textAlign: 'center'}}>
                    <NextLink href={`/rate-me/${username}`}>
                        <Box component="img"
                             sx={{
                                 height: 128,
                                 width: 'auto',
                                 margin: '0 auto'
                             }}
                             src={`/images/profile/approved_stamp_${i18n.language}.png`}
                             width="128"
                             height="128"
                        />
                    </NextLink>
                </Grid>
                <Grid item xs={12} sm={8} style={{textAlign: 'center'}}>
                    <Typography variant="body1" style={{marginBottom: 8}}>
                        {t('profile-accepted', {firstName: firstName})}
                    </Typography>
                    <NextLink href={`/rate-me/${username}`} passHref legacyBehavior>
                        <Button component="a" variant={'outlined'} color={'secondary'}
                        >{t('submit-a-rating')}</Button>
                    </NextLink>
                </Grid>
            </Grid>
        </CardContent>
    </Card>

}
